var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clients-through"},[(!_vm.selected_client)?_c('IQOSTable',{staticClass:"clients-table flex-full-table",attrs:{"cols":[
      {
        title: '#',
        width: 80,
        index: true
      },
      {
        title: _vm.$t('stats.clients.name'),
        key: 'name'
      },
      {
        title: _vm.$t('stats.clients.phone'),
        key: 'phone'
      },
      {
        title: _vm.$t('stats.clients.address'),
        key: 'address'
      },
      {
        title: _vm.$t('stats.clients.averange'),
        key: 'average_check',
        currency: 'symbol',
        default: '0'
      },
      {
        title: _vm.$t('client_base.total_orders'),
        key: 'total_orders',
        default: '0'
      },
      {
        title: _vm.$t('client_base.total_visits'),
        key: 'total_visits',
        width: 80,
        default: '0'
      } ],"rows":_vm.clients},on:{"rowClick":function (c) { return _vm.$router.push('/clients_base/'+c._id); }}}):_vm._e(),(_vm.selected_client)?_c('ClientCardModal',{attrs:{"client":_vm.selected_client},on:{"close":function($event){_vm.selected_client = null}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }